import React from 'react'

import { Link } from 'react-router-dom'
import Autocompete from '../JobRequisition/Autocompete'
import PageTitle from '../global/PageTitle/PageTitle'
import {
    Typography,
    TextField,
    InputAdornment,
    Box,
    Button,
    Checkbox,
    FormControl,
    FormLabel,
    RadioGroup,
    Radio,
    MenuItem,
    FormControlLabel,
    FormGroup,
    InputLabel,
    Select,
  } from "@material-ui/core";
  import './ExpenseLine.css';
export default function ExpenseLine() {
  return (
    <>
      <PageTitle title="Create Expense Report" />
      <br/>
      <div className='expense-header'>
       
      <div className='header-fields'>
        
      <h4>Pay To:</h4>
      <a>Contingest Worker: Test bar</a>
        </div>
       
        <div className='header-fields'>
         <h4> Status</h4>
          Draft
          </div>
          <div className='header-fields'>
          <h4> Personal</h4> 
          0.00 USD
          </div>
          <div className='header-fields'>
          <h4>Reimbursement</h4> 
          0.00 USD
          </div>
          <div className='header-fields'>
   Total<br/>
          0.00 USD
          </div>
      </div>
      <div className='Expense-report'>
         <div className='side-bar'></div>

   <div className='ExpenseLine'>

    <h2>Expense Line</h2> 
    <div className='Expense-att'>
    <div className='Expense-att-box'>
                <div className='att-box'>
                    <Typography style={{color: "black"}}>Drop files here</Typography>
                    <div style={{
                        background: "#A9A9A9",
                        borderRadius:"50%",
                        width: "25px",
                        height: "25px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: "12px",
                        margin: "6px 0 14px 0"
                    }}>or</div>
                    <Button 
                        variant="contained"
                        style={{
                            borderRadius: "25px",
                            background: "transparent",
                            border: "1px solid #808080",
                            boxShadow: "none" ,
                            fontWeight: "bold",
                            fontSize: "12px",
                            textTransform: "initial",
                            padding: "5px 20px"
                        }}    
                    >Select files</Button>
                </div>
              
                  <div className='attach-fields'>
                  <div className='input-f'>
                <h3>Date<span className="mandatory">*</span></h3>
                <TextField
                    id="date"   
                    type="date"
                    style={{ padding: "10px", color: "black" }}
                    defaultValue="YYYY/MM/DD"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  /> </div>
                  <div className='input-f'>
                  <h3>Expense Item<span className="mandatory">*</span></h3><Autocompete/></div>
                  <div className='input-f'><h3>Quantity<span className="mandatory">*</span></h3><input className='in-f' type="number"/></div>
                  <div className='input-f'><h3>Per Unit Amount<span className="mandatory">*</span></h3><input className='in-f' type="number"/></div>
                 <div className='input-f'><h3>Total Amount<span className="mandatory">*</span></h3><Autocompete/></div>
                 <div className='input-f'><h3>Currency<span className="mandatory">*</span></h3><Autocompete/></div>
                 <div className='input-f'><h3>Memo<span className="mandatory">*</span><input className='in-f' type="text"/></h3></div>
                 
                 </div>
                  </div>
   
      <div className='Expense-item'>
        <h2>Itemization</h2>
       <div className="item-prize"> Remaining Amount to Itemize   0.00/0.00 USD</div>
        <br/>
        <button className="Add">Add</button>
        <h2>Tax</h2><br/>
        <div className='tax'>
       Tax Code
              <Autocompete/>
            </div>
            Tax Amount   0.00
            <div className='tax'>
       Reciept included 
       <FormGroup>
       <FormControlLabel control={<Checkbox/>} label="" />
     </FormGroup>
            </div>
              </div>
              
              </div>
              <div className='next-bar'>
              <Link to="#">  <button className='back-btn'>Cancel</button></Link>
              <Link to="/org"> <button className='next-btn'>Next</button></Link>

</div>
   </div>
   </div>
   </>
  )
}
